import { render, staticRenderFns } from "./SitesOrders.vue?vue&type=template&id=e875c22a&"
import script from "./SitesOrders.vue?vue&type=script&lang=js&"
export * from "./SitesOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports